export function InfoCircleOutline({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.0003 2.8724C29.4475 2.87257 37.1273 10.5531 37.1273 20.0003C37.1271 29.4474 29.4474 37.1271 20.0003 37.1273C10.5531 37.1273 2.87257 29.4475 2.8724 20.0003C2.8724 10.553 10.553 2.8724 20.0003 2.8724ZM20.0003 3.79427C11.0643 3.79427 3.79427 11.0643 3.79427 20.0003C3.79445 28.9362 11.0644 36.2064 20.0003 36.2064C28.9361 36.2062 36.2062 28.9361 36.2064 20.0003C36.2064 11.0644 28.9362 3.79445 20.0003 3.79427Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.57895"
        />
        <path
          d="M20 12.8724C20.2473 12.8724 20.4609 13.086 20.4609 13.3333V21.6663C20.4609 21.9137 20.2473 22.1273 20 22.1273C19.7527 22.1273 19.5391 21.9137 19.5391 21.6663V13.3333C19.5391 13.086 19.7527 12.8724 20 12.8724Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.57895"
        />
        <path
          d="M19.6702 25.8618C19.8758 25.7762 20.1238 25.7763 20.3294 25.8618C20.4325 25.9048 20.5302 25.964 20.6234 26.0425C20.7022 26.1359 20.7619 26.2341 20.805 26.3374C20.8545 26.4564 20.8773 26.5698 20.8773 26.6665C20.8773 26.7634 20.8547 26.8774 20.805 26.9966L20.8001 27.0064L20.7962 27.0161C20.761 27.1077 20.7126 27.1862 20.6253 27.2876C20.5313 27.3672 20.4335 27.4279 20.3294 27.4712C20.2104 27.5208 20.0971 27.5434 20.0003 27.5435C19.9034 27.5435 19.7895 27.5209 19.6702 27.4712C19.5662 27.4278 19.4684 27.3673 19.3743 27.2876C19.2872 27.1863 19.2387 27.1077 19.2035 27.0161L19.1956 26.9966L19.1634 26.9077C19.1361 26.8211 19.1224 26.7391 19.1224 26.6665C19.1224 26.5697 19.1461 26.4565 19.1956 26.3374C19.2385 26.2345 19.297 26.1365 19.3753 26.0435C19.4689 25.9645 19.5667 25.905 19.6702 25.8618Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.57895"
        />
      </svg>
    </span>
  );
}
